import Grid from '@mui/material/Grid';
import { type AudienceData, AudienceOption } from '@openx/types/targeting/audience';
import { useEffect } from 'react';
import { useTargetingContext } from '../../utils/context/TargetingContext';
import { DrawerTopBox } from '../shared/TargetingDrawer/DrawerTopBox';
import { TypeOptionDropdown } from './components/TypeOptionDropdown';
import { TopBoxValueField } from './TopBoxValueField';

type TopBoxProps = {
  accountUid: string;
  onChange: (value?: string | Set<string>) => void;
  onChangeMulti: (values: Set<string>) => void;
  selectedType: AudienceOption;
  onTypeChange: (type: AudienceOption) => void;
  params: AudienceData | null;
};

export const TopBox = ({ accountUid, onChange, onChangeMulti, selectedType, onTypeChange, params }: TopBoxProps) => {
  const { useAudienceOptionsFetch, isOa } = useTargetingContext();
  const { options, isLoading, refetch } = useAudienceOptionsFetch(accountUid, selectedType);

  useEffect(() => {
    if (refetch && (selectedType === AudienceOption.DMP_SEGMENTS || selectedType === AudienceOption.OPEN_AUDIENCES)) {
      refetch();
    }
  }, [refetch, selectedType]);

  return (
    <DrawerTopBox>
      <Grid
        container
        spacing={1}
        sx={{
          alignItems: 'flex-end',
          flexGrow: 1,
        }}
      >
        {!isOa && (
          <Grid size={3}>
            <TypeOptionDropdown onChange={onTypeChange} value={selectedType} />
          </Grid>
        )}

        <Grid
          container
          spacing={1}
          sx={{
            mt: 1,
            flexGrow: 1,
          }}
        >
          <Grid size={12}>
            <TopBoxValueField
              selectedType={selectedType}
              params={params}
              onChange={onChange}
              onChangeMulti={onChangeMulti}
              accountUid={accountUid}
              options={options}
              isLoading={isLoading}
            />
          </Grid>
        </Grid>
      </Grid>
    </DrawerTopBox>
  );
};
